import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Msisdn } from './msisdns';
import { JsonResponse } from '../json-response';
import { UpdateLabelRequest } from './update-label-request';
import { Observable } from 'rxjs';
import { disabledProgress } from '../../config/progress.inteceptor';
import { MsisdnRequestDto } from '../../get-number/pricing-numbers/pricing-numbers';
import { LimitsExceededResponse } from '../../lead-generation/shared/domain/LimitsExceededResponse';
import { map } from 'rxjs/operators';
import { PaymentParams } from '../../account/account.model';
import { UpdateRecordingRequest } from "./update-recording-request";

@Injectable()
export class MsisdnService {
  constructor(private http: HttpClient) {}

  msisdns() {
    return this.http.get<Msisdn[]>('/msisdns');
  }

  historicalMsisdns() {
    return this.http.get<Msisdn[]>('/record-events/historical-msisdns');
  }

  inboundableMsisdns() {
    return this.http.get<Msisdn[]>('/msisdns/inboundable');
  }

  limitsExceeded(): Observable<boolean> {
    return this.http
      .get<LimitsExceededResponse>('/msisdns/limits-exceeded')
      .pipe(map(response => response.limitsExceeded));
  }

  projectNumbers(projectId) {
    return this.http.get(`/projects/${projectId}/numbers`);
  }

  updateLabel(id: number, body: UpdateLabelRequest) {
    return this.http.put<void>(`/msisdns/${id}`, body);
  }

  updateRecordingEnabled(id: number, body: UpdateRecordingRequest) {
    return this.http.put<void>(`/msisdns/${id}/recording`, body).toPromise();
  }

  assign(request: MsisdnRequestDto): Observable<PaymentParams> {
    return this.http.post<PaymentParams>('/msisdns/assign', request);
  }

  assignInitial(request: MsisdnRequestDto): Observable<any> {
    return this.http.post('/msisdns/assign-initial', request);
  }

  isLabelExisting(label: string): Observable<JsonResponse> {
    const httpParams = new HttpParams({
      fromObject: {
        label: label
      }
    });

    return this.http.get<JsonResponse>(`/msisdns/exists`, { params: httpParams, ...disabledProgress });
  }
}
